import React from 'react';

export const ArrowRightIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.16669 10H15.8334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4.16669L15.8333 10L10 15.8334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 4.16669V15.8334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16669 10H15.8334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 17.5L13.875 13.875"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ArrowLeftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M7.49827 16.3755C7.84315 16.8069 7.77304 17.4361 7.34167 17.781C6.91031 18.1259 6.28104 18.0558 5.93616 17.6244L2.43789 13.2489C1.85404 12.5186 1.85404 11.4813 2.43789 10.751L5.93616 6.3755C6.28104 5.94414 6.91031 5.87403 7.34167 6.21891C7.77304 6.56379 7.84315 7.19306 7.49827 7.62442L4.79951 11L21.0014 11C21.5537 11 22.0014 11.4477 22.0014 12C22.0014 12.5522 21.5537 13 21.0014 13L4.79951 13L7.49827 16.3755Z"
          fill="#648BEF"/>
  </svg>

);

export const AvatarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.9987 15.9993C18.2999 15.9993 20.1654 14.1339 20.1654 11.8327C20.1654 9.5315 18.2999 7.66602 15.9987 7.66602C13.6975 7.66602 11.832 9.5315 11.832 11.8327C11.832 14.1339 13.6975 15.9993 15.9987 15.9993Z" stroke="#EDF2F7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M23.1565 24.3333C23.1565 21.1083 19.9482 18.5 15.9982 18.5C12.0482 18.5 8.83984 21.1083 8.83984 24.3333" stroke="#EDF2F7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="16" cy="16" r="15.25" stroke="#EDF2F7" stroke-width="1.5"/>
</svg>

)